function FeedPostFrontHeadline({
  text,
  className
}: {
  text: string
  className?: string
}) {
  return (
    <h2
      className={`${className} text-2xl text-blue-400 font-semibold font-serif word-break`}>
      {text}
    </h2>
  )
}

export default FeedPostFrontHeadline
